import React from 'react';
import { Button, Stack } from '@mui/material';
import { FaWhatsapp } from "react-icons/fa";
import Title from './Title';
import Paragraph from './Paragraph';

const GetInTouch = () => {
    return (
        <>
            {/* Sección de contacto */}
            <Stack
                component="section"
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{
                    py: 10,
                    mx: 6,
                }}
            >
                <Title
                    text="Contáctanos"
                    textAlign="center"
                />
                <Paragraph
                    text="¿Tienes alguna duda? Comunícate con nosotros por WhatsApp."
                    maxWidth="sm"
                    mx={0}
                    textAlign="center"
                />
                <Button
                    component="a"
                    href="https://api.whatsapp.com/send?phone=5219612283232&text=¡Hola!"
                    target="_blank"
                    variant="contained"
                    size="medium"
                    sx={{
                        width: '200px',
                        height: '50px',
                        fontSize: '1rem',
                        fontWeight: 600,
                        color: '#fff',
                        backgroundColor: 'rgb(51, 64, 64)',
                        borderRadius: '10px',
                        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                        backgroundColor: 'rgb(41, 54, 54)',
                        transform: 'scale(1.05)',
                        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                        },
                    }}
                    >
                    <FaWhatsapp size={20} /> {/* Icono de WhatsApp */}
                    WhatsApp
                </Button>
            </Stack>
        </>
    );
};

export default GetInTouch;
